// import { apiSlice } from '../api/apiSlice'
// import 

import { id } from "date-fns/locale";
import { muiDataGridStarted } from "../apiutils";
import { apiSlice } from "../createApiSlice";

const INBOUND_BASE = "/serialnumbers";
const buildUrl = (endpoint) => INBOUND_BASE + endpoint;

const serialNumbersApiSlice =  apiSlice.injectEndpoints({
    endpoints: builder => ({
        createSerialNumber: builder.mutation({
            query: body => {
                const url = buildUrl(`/add`);
                return {
                    url,
                    method: "POST",
                    body,
                };
            }
        }),
        updateSerialNumber: builder.mutation({
            query: body => {
                const url = buildUrl(`/${body.id}`);
                return {
                    url,
                    method: "PUT",
                    body,
                };
            }
        }),
        deleteSerialNumber: builder.mutation({
            query: id => {
                const url = buildUrl(`/${id}`);
                return {
                    url,
                    method: "DELETE",
                };
            }
        })
    })
});

export const {
    useUpdateSerialNumberMutation,
    useCreateSerialNumberMutation,
    useDeleteSerialNumberMutation,
  } = serialNumbersApiSlice;
